export default "/react/logoMatomba-f2be6bee.png";